import { Avatar } from '@vnetwork/ui/primitives';

/**
 * Account-preset avatar: an accent-solid disc with the person's initials, or the
 * photo when one is available and loads. A thin wrapper over the shared @ui
 * `Avatar` that fixes the account look (solid accent, circular, px-sized) so the
 * profile header, vcard, and activity timelines stay consistent.
 */
export function AccountAvatar({
  name,
  src,
  size = 48,
}: {
  name: string;
  src?: string | null;
  size?: number;
}) {
  return (
    <Avatar
      name={name}
      src={src}
      size={size}
      appearance="solid"
      tone="accent"
    />
  );
}
